export class AssignDeliveringTask {
    public orderCode: string;
}
